import Playground from "./pages/Playground";

export default function App() {
  return <Playground />;
}
